module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('default-chart', {
    attrs: {
      "labels": _vm.label,
      "items": _vm.data,
      "height": 120
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1e5cab08!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PriceHistory/Chart.vue
// module id = 1244
// module chunks = 2